/*
 * @Author: Cphayim
 * @Date: 2020-09-10 19:30:53
 * @LastEditTime: 2022-02-11 02:03:18
 * @Description: Store
 */
import Vue from 'vue'
import Vuex from 'vuex'

import * as modules from './modules'
import GlobalModule from './global.store'

Vue.use(Vuex)
const store = new Vuex.Store({
  ...GlobalModule,
  modules,
})

export default store
